import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  period: {
    '@$': 'focusedRange',
  },
  selection: {
    '{}': {
      name: 'PI Performance',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Density',
                          points: {
                            '@': 'densityQuery',
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'ASF',
                  yLabel: {
                    '++': [
                      {
                        '@$': 'financialVolume',
                      },
                      ' Performance',
                    ],
                  },
                },
              },
            ],
          },
          type: 'scatter',
        },
      },
      overflowActions: {
        '[]': [
          {
            '{}': {
              icon: 'atn-icon atn-link',
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      goto: {
                        '{}': {
                          segmentId: 'pi',
                          navigationId: 'explore',
                        },
                      },
                    },
                  },
                  operation: 'ui.navigate',
                },
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2025',
        },
        start: {
          $date: '1/1/2025',
        },
      },
    },
    financialVolume: 'MTDC',
  },
  subqueries: {
    densityQuery: {
      filter: {
        and: [
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'asfMin',
                  },
                  null,
                ],
              },
              {
                '>=': [
                  {
                    '+': {
                      '@': 'piRoom',
                    },
                  },
                  {
                    '@$': 'asfMin',
                  },
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'asfMax',
                  },
                  null,
                ],
              },
              {
                not: {
                  '>=': [
                    {
                      '+': {
                        '@': 'piRoom',
                      },
                    },
                    {
                      '@$': 'asfMax',
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '{}': {
          x: {
            '+': {
              '@': 'piRoom',
            },
          },
          y: {
            '+': {
              '@': 'piExpense',
            },
          },
          name: {
            '++': [
              {
                '@.': '!name',
              },
              ': ',
              {
                'fmt.num': [
                  {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@>': 'x',
                            },
                            0,
                          ],
                        },
                        0,
                      ],
                      {
                        if: [
                          [
                            {
                              and: [
                                {
                                  not: {
                                    '=': [
                                      {
                                        '@>': 'x',
                                      },
                                      null,
                                    ],
                                  },
                                },
                                {
                                  '!=': [
                                    {
                                      '@>': 'x',
                                    },
                                    0,
                                  ],
                                },
                              ],
                            },
                            {
                              '/': [
                                {
                                  '@>': 'y',
                                },
                                {
                                  '@>': 'x',
                                },
                              ],
                            },
                          ],
                          0,
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          onClick: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {
                              piRecordId: {
                                '@.': '!id',
                              },
                              orgEntityId: 'null',
                            },
                          },
                          navigationId: 'explore',
                        },
                      },
                    },
                  },
                  operation: 'ui.navigate',
                },
              },
            },
          },
        },
      },
      subqueries: {
        piRoom: {
          target: 'ent:!personnel:!employee',
          selection: {
            '??': [
              {
                '+': {
                  '@': 'spaces',
                },
              },
              0,
            ],
          },
          subqueries: {
            spaces: {
              ref: {
                attr: 'attr:ent#!person_space#!entry:!space',
              },
              using: 'spaceAssignments',
              filter: {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'spaceType',
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': [
                          '!space_use',
                          {
                            ref: {
                              entity: '!group',
                            },
                          },
                        ],
                      },
                      {
                        '@>': [
                          {
                            '@$': 'spaceType',
                          },
                          'ent:!space_use:!group',
                        ],
                      },
                    ],
                  },
                ],
              },
              target: 'ent:!space:!room',
              selection: {
                '@.': '!sqft',
              },
            },
            spaceAssignments: {
              ref: {
                attr: 'attr:ent#!person_space#!entry:!personnel',
              },
              target: 'ent:!person_space:!entry',
            },
          },
        },
        piExpense: {
          target: 'ent:!personnel:!employee',
          selection: {
            '+': {
              '@': 'expenses',
            },
          },
          subqueries: {
            projPis: {
              ref: {
                attr: 'attr:ent#!proj_pis#!entry:!pi',
              },
              target: 'ent:!proj_pis:!entry',
            },
            expenses: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              using: 'projects',
              filter: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'financialVolume',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'MTDC',
                      ],
                    },
                  ],
                  {
                    not: {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'IDC',
                      ],
                    },
                  },
                ],
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '@.': '!amount',
              },
              subqueries: {
                project: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  target: 'ent:!projects:!proj',
                },
                costType: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!cost_type',
                  },
                },
              },
            },
            projects: {
              ref: {
                attr: 'attr:ent#!proj_pis#!entry:!proj',
              },
              using: 'projPis',
              target: 'ent:!projects:!proj',
            },
          },
        },
      },
    },
  },
}
